import {
	AUTH_WINDOW_WIDTH,
	ELECTRON_TITLE_BAR_HEIGHT,
	MAIN_WINDOW,
	AUTH_CONTENT_HEIGHT,
	getAuthWindowSize
} from '../shared/electronWindowConfig.js';

export { ELECTRON_TITLE_BAR_HEIGHT, getAuthWindowSize };

const AUTH_ROUTE_PAGES = {
	'/login': 'login',
	'/login/demo': 'demoLogin',
	'/register': 'register',
	'/password/reset': 'resetPwd'
};

export function resizeAuthWindow(page = 'login', options = {}) {
	if (!window.electronAPI) {
		return;
	}
	const contentHeight = AUTH_CONTENT_HEIGHT[page] || AUTH_CONTENT_HEIGHT.login;
	window.electronAPI.sendEvent('resize', {
		width: AUTH_WINDOW_WIDTH,
		height: contentHeight + ELECTRON_TITLE_BAR_HEIGHT,
		authWindow: true,
		maximizable: false,
		forceSize: true,
		recenter: !!options.recenter
	});
}

export function resizeMainWindow(options = {}) {
	if (!window.electronAPI) {
		return;
	}
	const forceSize = options.forceSize !== false;
	window.electronAPI.sendEvent('resize', {
		width: MAIN_WINDOW.width,
		height: MAIN_WINDOW.height,
		minWidth: MAIN_WINDOW.minWidth,
		minHeight: MAIN_WINDOW.minHeight,
		authWindow: false,
		maximizable: true,
		forceSize,
		recenter: !!options.recenter
	});
}

export function ensureMainWindowMode() {
	if (!window.electronAPI) {
		return;
	}
	window.electronAPI.sendEvent('resize', {
		minWidth: MAIN_WINDOW.minWidth,
		minHeight: MAIN_WINDOW.minHeight,
		authWindow: false,
		maximizable: true,
		forceSize: false,
		recenter: false
	});
}

export function syncElectronWindowForRoute(path, fromPath = '') {
	if (!window.electronAPI) {
		return;
	}
	if (path.startsWith('/home')) {
		const enteringHome = !fromPath || !fromPath.startsWith('/home');
		if (enteringHome) {
			resizeMainWindow({ recenter: true, forceSize: true });
		} else {
			ensureMainWindowMode();
		}
		return;
	}
	const page = AUTH_ROUTE_PAGES[path];
	if (page) {
		resizeAuthWindow(page);
	}
}
